/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import { toHeaderCase, toLowerCase } from 'js-convert-case';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import moment from 'moment';
import { apiConfig } from '@pages/ActualDetailPage/config/api.config';
import { transactionActualDetailConfig } from '@pages/ActualDetailPage/config/transactionReceipt.config';

export interface IFormatTimelinePluginMethods extends IPluginMethodMap {
  getFormatTimeline(args?: any): Promise<any>;
}

export class FormatTimelinePlugin implements IAgentPlugin {
  readonly methods: IFormatTimelinePluginMethods;

  constructor() {
    this.methods = {
      getFormatTimeline: this.getFormatTimeline.bind(this),
    };
  }

  async getFormatTimeline(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    return {
      // products: this.formatProducts(this.products),
      title: toHeaderCase(
        args?.data?.find((item: any) => item?.id === args?.cardId)?.action ?? ''
      ),
      data: this.getDetail(args),
    };
  }

  private getDetail(res: any) {
    console.log(`timeline details`, res);
    let _temp = res?.data?.find((item: any) => item?.id === res?.cardId);
    let _timelineDetail = this.getTimeLineDetail(_temp?.payload);
    console.log(`_temp id`, _temp);
    if (_timelineDetail) {
      return {
        type: 'multi-col-list',
        numberOfColumns: '3',
        data: [..._timelineDetail],
      };
    } else return null;
  }

  private getTimeLineDetail(res: any) {
    let _temp = [];
    if (res?.discountedPremium === res?.premium) {
      delete res?.discountedPremium;
    }
    if (res) {
      for (const [key, value] of Object.entries(res)) {
        if (typeof value === 'string') {
          if (toLowerCase(key)?.includes('date')) {
            _temp.push({
              title: toHeaderCase(key),
              subTitle: moment(value).format('LLL'),
            });
          } else if (key === 'paymentMethod') {
            _temp.push({
              title: toHeaderCase(key),
              subTitle: toHeaderCase(value),
            });
          } else if (key === 'transactionReceiptURL') {
            _temp.push({
              title: toHeaderCase('Blockchain Proof'),
              // subTitle: value,
              subTitle: 'View Details',
              isModal: true,
              data: transactionActualDetailConfig,
            });
          } else if (key === 'receiptNo') {
            _temp.push({
              title: toHeaderCase('Transaction Id'),
              subTitle: value,
            });
          } else if (key === 'instrumentNo') {
            _temp.push({
              title: toHeaderCase('Receipt Number'),
              subTitle: value,
            });
          } else {
            _temp.push({
              title: toHeaderCase(key),
              subTitle: value,
            });
          }
        }
        if (typeof value === 'object' && key === 'address') {
          _temp.push({
            title: toHeaderCase(key),
            subTitle: `${value?.addressLine1}, ${value?.city}, ${value?.country}`,
          });
        }
      }
    }
    return _temp;
  }

  private formatProducts(products: any) {
    return products.map((product: any) => product);
  }
}
